export const environment = {
  production: true,
  AUTHPORTAL_API_URL: "https://accounts.rinknet.com/api/",
  PRESSROOM_API_URL: 'https://scouting.1rink.com/',
  ONESIGNAL_APP_ID: "d02454b9-d8fe-4e4d-9e01-217c09c7a0a6",
  IMAGE_URL: "http://pc.rinknet.com/images/",
  PRINT_LINES_URL: "https://reports.rinknet.com/pressroomlineups.aspx",
  OPS_SIGN_IN_URL: "https://ops.rinknet.com/#/signin",
  ONERINK_URL: "https://app.1rink.com/",
  MANAGE_SUBSCRIPTION_URL: "https://billing.stripe.com/p/login/dR6fZT9j26ijgh23cc",
  DEFAULT_PRINT_LAYOUT_ID: 2000
};
